import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import { FilterChip } from "../components/Button";
import ProjectCard from "../components/ProjectCard";
import {
  filtersWithProjects,
  projectMatchesFilter,
  projectMatchesSearch,
} from "../utils/projectFilters";

const Work = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    let active = true;
    apiClient
      .getProjects()
      .then((content) => active && setData(content))
      .catch(() => active && setError("Unable to load projects."));
    return () => {
      active = false;
    };
  }, []);

  if (error) {
    return <div className="page-shell py-20 text-center text-muted">{error}</div>;
  }

  if (!data) {
    return <div className="page-shell py-20 text-center font-mono text-xs uppercase tracking-widest text-muted">Loading projects…</div>;
  }

  if (data.comingSoon) {
    return (
      <section className="grid-bg page-enter flex min-h-[70vh] items-center border-b border-line">
        <div className="page-shell py-24">
          <p className="eyebrow">Build queue // Pending</p>
          <h1 className="mt-5 max-w-4xl font-display text-5xl font-semibold tracking-[-0.055em] text-textmain md:text-8xl">{data.header.title}<span className="text-accent">.</span></h1>
          <p className="mt-7 max-w-2xl text-base leading-7 text-muted">{data.header.description}</p>
          <div className="mt-10 h-px max-w-lg bg-line"><span className="block h-px w-1/3 bg-accent" /></div>
        </div>
      </section>
    );
  }

  const visibleProjects = data.projects.filter((project) => !project.isHidden);
  const availableFilters = filtersWithProjects(data.filters, visibleProjects);
  const filteredProjects = visibleProjects.filter((project) => {
    return projectMatchesFilter(project, activeFilter)
      && projectMatchesSearch(project, searchQuery);
  });
  return (
    <section className="page-enter">
      <header className="grid-bg border-b border-line">
        <div className="page-shell py-20 md:py-28">
          <p className="eyebrow">Archive // Selected builds</p>
          <h1 className="mt-5 font-display text-5xl font-semibold tracking-[-0.055em] text-textmain md:text-8xl">{data.header.title}<span className="text-accent">.</span></h1>
          <p className="mt-6 max-w-2xl text-base leading-7 text-muted">{data.header.description}</p>
        </div>
      </header>

      <div className="page-shell py-16 md:py-20">
      <div className="mb-10 grid gap-4 border-y border-line py-4 lg:grid-cols-[minmax(240px,1fr)_auto] lg:items-center">
        <label className="flex items-center gap-3 border border-line bg-card px-3 py-2.5">
          <span className="font-mono text-[10px] text-accent" aria-hidden="true">{data.search.icon || "/"}</span>
          <input
            id="project-search"
            name="project-search"
            type="text"
            aria-label={data.search.placeholder}
            placeholder={data.search.placeholder}
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            className="w-full bg-transparent font-mono text-[11px] text-textmain outline-none placeholder:text-muted"
          />
        </label>

        <div className="flex flex-wrap gap-2">
          {availableFilters.map((filter) => (
            <FilterChip
              key={filter.id}
              active={activeFilter === filter.id}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </FilterChip>
          ))}
        </div>
      </div>

      <div className="flex w-full flex-col gap-8">
        {filteredProjects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
        {visibleProjects.length === 0 && (
          <div className="editorial-card grid min-h-72 place-items-center p-8 text-center">
            <div><p className="eyebrow mb-4">Archive empty</p><h3 className="font-display text-2xl font-semibold text-textmain">
              {data.search.noProjectsTitle}
            </h3>
            <p className="mt-2 text-muted">{data.search.noProjectsMessage}</p>
            </div>
          </div>
        )}
        {visibleProjects.length > 0 && filteredProjects.length === 0 && (
          <div className="editorial-card w-full p-10 text-center font-mono text-[11px] uppercase tracking-wide text-muted">{data.search.emptyMessage}</div>
        )}
      </div>
      </div>
    </section>
  );
};

export default Work;
